import { createStore } from 'vuex'
import movies from './movies.js'
import auth from './auth.js'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    movies,
    auth,
  }
})
